export default class TimeDelayNodeData {
  constructor(days = 0, hours = 0, minutes = 0) {
    this.days = days
    this.hours = hours
    this.minutes = minutes
  }
}
